import Image from "next/image";
import React from "react";
import { Dashboard } from "@/assets/images";

function Hero() {
  return (
    <section className="pt-28 sm:pt-60">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-4xl text-center">
          <h1 className="px-6 text-lg text-gray-600">Smart CRE Finance Platform, made for Capital Advisors</h1>
          <p className="mt-5 text-4xl font-bold leading-tight text-gray-900 sm:text-5xl sm:leading-tight lg:text-6xl lg:leading-tight">
            Revolutionizing the CRE Capital Advisory
            <span className="relative inline-flex sm:inline">
              <span className="absolute inset-0 size-full bg-gradient-to-r from-[#44BCFF] via-[#FF44EC] to-[#FF675E] opacity-30 blur-lg" />
              <span className="relative"> Business </span>
            </span>
          </p>

          <div className="mt-9 px-8 sm:flex sm:items-center sm:justify-center sm:space-x-5 sm:px-0">
            <a
              href="#signup"
              title=""
              className="inline-flex w-full items-center justify-center rounded-xl border-2 border-transparent bg-gray-900 px-8 py-3 text-lg font-bold text-white transition-all duration-200 hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-900 focus:ring-offset-2 sm:w-auto"
              role="button"
            >
              Get more deals closed
            </a>
          </div>

          <p className="mt-8 text-base text-gray-500">30 Days free trial · No credit card required</p>
        </div>
      </div>

      <div className="mt-20 pb-32">
        <div className="relative">
          <div className="absolute inset-0 h-2/3 bg-gray-50" />
          <div className="relative mx-auto">
            <div className="lg:mx-auto lg:max-w-6xl">
              <Image className="scale-110" src={Dashboard} alt="Illustration" height={800} priority />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
